import { render } from "./StakeholderTable.vue?vue&type=template&id=1605f6a8&scoped=true"
import script from "./StakeholderTable.vue?vue&type=script&lang=js"
export * from "./StakeholderTable.vue?vue&type=script&lang=js"

import "./StakeholderTable.vue?vue&type=style&index=0&id=1605f6a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1605f6a8"]])

export default __exports__